import Vue from "vue";
import VueRouter from "vue-router";
import { AWSEventBus } from "@bag-era/cognito-authentication";
import cognitoconfig from "../aws-config";
import Auth from "@aws-amplify/auth";
import store from "../store";
import DashboardLayout from "../views/Layout/DashboardLayout.vue";
// -- Auth components view
import LoginView from "../views/LoginView.vue";
import ResetPwdView from "../views/ResetPwdView.vue";
import ChangeTmpPwdView from "../views/ChangeTmpPwdView.vue";

Auth.configure(cognitoconfig);

// -- HOME PAGE
const InformationsAttributes = () =>
  import("../views/InformationsAttributes.vue");

const Groups = () => import("../views/Groups.vue");
const Parkings = () => import("../views/Parkings.vue");
const ParkingDetails = () => import("../views/ParkingDetails.vue");

Vue.use(VueRouter);

/**
 * CHECK IF USER IS AUTHENTICATED BEFORE ROUTE TO PAGE
 */
const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLogged) {
    next();
    return;
  }

  next("/login");
};

const routes = [
  {
    path: "/login",
    name: "Login",
    component: LoginView,
    meta: { requiresUser: false, requiresEnterprise: false },
  },
  {
    path: "/resetpwd",
    name: "ResetPwdView",
    component: ResetPwdView,
    meta: { requiresUser: false, requiresEnterprise: false },
  },
  {
    path: "/changetmppwd",
    name: "ChangeTmpPwdView",
    component: ChangeTmpPwdView,
    meta: { requiresUser: false, requiresEnterprise: false },
  },
  {
    path: "/",
    name: "Dashboard",
    redirect: "/informationsattributes",
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "informationsattributes",
        name: "Information and attributes",
        component: InformationsAttributes,
        beforeEnter: ifAuthenticated,
      },
      {
        path: "groups",
        name: "Groups",
        component: Groups,
        beforeEnter: ifAuthenticated,
      },
      {
        path: "parkings",
        name: "Parkings",
        component: Parkings,
        beforeEnter: ifAuthenticated,
      },
      {
        path: "parkings/:id",
        name: "ParkingDetails",
        component: ParkingDetails,
        beforeEnter: ifAuthenticated,
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

// -- COGNITO AWS AMPLIFY LOGIN
AWSEventBus.$on("loggedIn", async (data) => {
  const user = {
    username: data.username,
    Session: data.Session,
    info: data.signInUserSession.idToken.payload,
  };
  store.dispatch("setLogged", true);
  store.dispatch("setUser", user);
  router.push("/");
});

AWSEventBus.$on("resetPassword", async (data) => {
  router.push({ path: "/resetpwd", query: { username: data.username } });
});

AWSEventBus.$on("pwdChanged", async () => {
  router.push({ path: "/login" });
});

AWSEventBus.$on("changeTmpPassword", async (data) => {
  router.push({
    path: "/changepwd",
    query: { username: data.username, password: data.password },
  });
});

AWSEventBus.$on("selectEnterprise", async () => {
  const enterprise = store.getters.enterprise;
  const awsExports = {
    aws_project_region: enterprise.poolInfo.region,
    aws_cognito_region: enterprise.poolInfo.region,
    aws_user_pools_id: enterprise.poolInfo.userPoolId,
    aws_user_pools_web_client_id: enterprise.poolInfo.clientId,
  };
  Auth.configure(awsExports);
  router.push({ path: "/login" });
});

AWSEventBus.$on("loggedOut", async () => {
  store.dispatch("setLogged", false);
  store.dispatch("setUser", null);
  router.push({ path: "/login" });
});

AWSEventBus.$on("changeEnterprise", async () => {
  store.dispatch("setEnterprise", null);
  Auth.configure({});
  router.push({ path: "/selectenterprise" });
});

router.beforeResolve(async (to, from, next) => {
  const user = store.getters.isLogged;
  const cognitouser = store.getters.cognitoUser;
  const enterprise = store.getters.enterprise;
  if (to.matched.some((record) => record.meta.requiresEnterprise)) {
    if (!enterprise) {
      return next({
        path: "/selectenterprise",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  if (to.matched.some((record) => record.meta.requiresUser)) {
    if (!user || cognitouser.info["cognito:groups"] === undefined) {
      return next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else if (to.path === "/login") {
    if (user) {
      return next({
        path: "/",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  return next();
});

export default router;
